import { Controller } from "@hotwired/stimulus"

// Shows or hides the Budowa picker on the invoice form depending on the
// chosen cost category. Picking "Koszt ogólny" hides the picker AND clears
// its hidden input so the server doesn't receive a stale construction_id.
// "Koszt budowy" / "Nieprzypisana" keep the picker visible.
export default class extends Controller {
  static targets = ["picker", "constructionInput", "constructionHidden", "category"]

  connect() {
    this._apply()
  }

  update() {
    this._apply()
  }

  _apply() {
    const selected = this.categoryTargets.find(el => el.checked)?.value
    const general = selected === "general"
    if (general) {
      this.pickerTarget.classList.add("hidden")
      if (this.hasConstructionInputTarget) this.constructionInputTarget.value = ""
      if (this.hasConstructionHiddenTarget) this.constructionHiddenTarget.value = ""
    } else {
      this.pickerTarget.classList.remove("hidden")
    }
  }
}
